import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Switch from '@repo/ui/switch'

import useTranslate from '../../lib/hooks/use-translate'

interface StatusToggleProps {
  isActive: boolean
  onToggle: (checked: boolean) => void
  activeLabel?: string
  inactiveLabel?: string
  disabled?: boolean
}

export const StatusToggle = ({
  isActive,
  onToggle,
  activeLabel,
  inactiveLabel,
  disabled = false
}: StatusToggleProps) => {
  const { t } = useTranslate()
  return (
    <Switch
      checked={isActive}
      label={
        !isActive
          ? (inactiveLabel ?? t('common.status.toggle.inactive'))
          : (activeLabel ?? t('common.status.toggle.active'))
      }
      borderClassName={cn('gap-2 bg-red-light p-2 rounded-lg', {
        'bg-green-light': isActive
      })}
      labelVariant="label-medium"
      color={isActive ? tailwindColors.green.DEFAULT : tailwindColors.red.DEFAULT}
      disabled={disabled}
      onCheckedChange={onToggle}
      variant={isActive ? 'success' : 'danger'}
    />
  )
}
